import { gql } from '@apollo/client'

export default gql`
    query getAdminJobRequestsQuality(
        $limit: Int!
        $offset: Int
        $filters: AdminJobRequestFiltersInput
        $sort: AllowedAdminJobRequestSort
    ) {
        adminJobRequests(
            limit: $limit
            offset: $offset
            filters: $filters
            sort: $sort
        ) {
            totalCount
            items {
                id
                name
                rfqNumber
                inspectionStatus
                businessUnit
                project {
                    id
                    isSecurePlus
                    name
                }
                vendorDueDate
                salesOrderName
                priority
                linesWithWorkOrderMapping {
                    id
                    productQty
                    processName
                    processType
                    materialName
                }
                jobRequestAttachments {
                    type
                    source
                    attachment {
                        id
                        mimeType
                    }
                }
                mfgPartner {
                    id
                    displayName
                }
                mfgDri {
                    id
                    displayName
                }
                hasPostProcess
                productionStage
                payout
                secondaryProcessStartDate
                riskStatus
                process {
                    id
                    name
                }
                status
            }
        }
    }
`

export const mpCountriesQuery = gql`
    query mpCountriesQuality {
        mpCountries {
            id
            name
        }
    }
`
